import Button from "../../components/Button";

function AnnouncementBanner({ message, link }: { message: string, link?: string }) {
  return (
    <div className="bg-blue-900 text-white p-3">
      <div className="font-semibold max-sm:px-3">
        {message}
        <a href={link} target="_blank" rel="noreferrer">
          <Button text="Book now" color="secondary" size="small" className="max-sm:block max-sm:mt-3 max-sm:mx-auto"/>
        </a>
      </div>
    </div>
  );
}

export default AnnouncementBanner;